import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  padding-left: 42px;
  font-size: ${(p) => p.theme.fontSmaller};

  ${(p) => p.theme.activeControlStyle};

  a {
    position: absolute;
    ${(p) => p.theme.fitContainerStyle};
  }
`;

export const Photo = styled.img`
  width: 35px;
  height: 35px;

  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;

  border-radius: 100%;
  object-fit: cover;
`;
